import { render, staticRenderFns } from "./ServiceAgreement.vue?vue&type=template&id=287c75a6&scoped=true"
import script from "./ServiceAgreement.vue?vue&type=script&lang=js"
export * from "./ServiceAgreement.vue?vue&type=script&lang=js"
import style0 from "./ServiceAgreement.vue?vue&type=style&index=0&id=287c75a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c75a6",
  null
  
)

export default component.exports